import { Image, Money } from '@belong/ui';
import { STRINGS } from 'post-inspection/constants/strings';
import type { ReportPayment } from 'post-inspection/models/improvements-report';

type Props = {
  homeownerReportPayment: ReportPayment;
  totalCost: number;
};

export const MoveoutHomeownerImprovementsTotal = ({
  totalCost,
  homeownerReportPayment,
}: Props) => {
  return (
    <>
      <div className="mb-md flex justify-between">
        <p className="text-p1 font-semibold md:text-body">
          {STRINGS['homeowner.moveoyt.total.title']}
        </p>
        <p className="flex flex-col items-end">
          <Money
            fontWeight="semibold"
            format="DOLLARS_NO_CENTS"
            className="text-p1 md:text-body"
            value={totalCost}
          />
          {Boolean(homeownerReportPayment.groupDueNow) && (
            <div className="-mt-2xs">
              <Money
                as="span"
                className="text-p1"
                format="DOLLARS_WITH_CENTS"
                value={homeownerReportPayment.groupDueNow}
              />
              &nbsp;
              <span className="text-p1">{STRINGS['due-now']}</span>
            </div>
          )}
        </p>
      </div>
      <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between md:items-center">
        <div className="mb-lg flex items-start sm:mb-0 md:items-center">
          <div className="mr-xs">
            <Image
              alt="plan-it"
              className="h-auto w-xl"
              src="/improvement-reports/plan.svg"
            />
          </div>
          <div className="flex flex-col">
            <p className="mb-2xs text-p1 md:text-body">
              {STRINGS['up-to-12-month-financing-available']}
            </p>
            <div className="-mt-xs flex md:hidden">
              <span className="text-p1 font-semibold md:text-body">
                {STRINGS.est}
              </span>
              &nbsp;
              <Money
                as="span"
                fontWeight="semibold"
                format="DOLLARS_NO_CENTS"
                className="text-p1 md:text-body"
                value={homeownerReportPayment.monthlyPayment}
              />
              <span className="text-p1 font-semibold md:text-body">
                {STRINGS.monthly}
              </span>
            </div>
          </div>
        </div>

        <div className="hidden justify-end md:flex">
          <span className="font-semibold">{STRINGS.est}</span>
          &nbsp;
          <Money
            as="span"
            fontWeight="semibold"
            format="DOLLARS_NO_CENTS"
            value={homeownerReportPayment.monthlyPayment}
          />
          <span className="font-semibold">{STRINGS.monthly}</span>
        </div>
      </div>
    </>
  );
};
